(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dispatch-promise"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dispatch-promise')) {
    customElements.define('dispatch-promise', class extends HTMLElement {
      connectedCallback() {
        this.render();
        // Minute resolution: the message changes at the cut-off and the countdown ticks, nothing faster.
        this.timer = setInterval(() => this.render(), 30000);
      }
      disconnectedCallback() { clearInterval(this.timer); }

      /** Calendar date + hour/minute in the store's time zone, as plain numbers (DST-safe). */
      now() {
        const tz = this.getAttribute('timezone') || 'UTC';
        const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
          .formatToParts(new Date()).map(p => [p.type, p.value]));
        return { date: Date.UTC(+parts.year, +parts.month - 1, +parts.day), minutes: +parts.hour * 60 + +parts.minute };
      }
      isWorkday(utc) {
        const days = this.getAttribute('days') === 'mon_sat' ? [1, 2, 3, 4, 5, 6] : [1, 2, 3, 4, 5];
        const iso = new Date(utc).toISOString().slice(0, 10);
        return days.includes(new Date(utc).getUTCDay()) && !this.holidays.has(iso);
      }
      nextWorkday(utc) {
        let d = utc;
        for (let i = 0; i < 30; i++) { d += 86400000; if (this.isWorkday(d)) return d; }
        return d;
      }
      label(utc, today) {
        if (utc === today) return this.dataset.todayWord;
        if (utc === today + 86400000) return this.dataset.tomorrow;
        return new Intl.DateTimeFormat(this.getAttribute('date-locale') || document.documentElement.lang || undefined, { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'short' }).format(new Date(utc));
      }
      render() {
        this.holidays = new Set((this.getAttribute('holidays') || '').split(',').filter(Boolean));
        const headline = this.querySelector('[data-dispatch-headline]');
        if (!headline) return;
        let now;
        try { now = this.now(); } catch { return; }
        const cutoff = Number(this.getAttribute('cutoff')) * 60;
        const beforeCutoff = this.isWorkday(now.date) && now.minutes < cutoff;
        const dispatch = beforeCutoff ? now.date : this.nextWorkday(now.date);
        this.dataset.state = beforeCutoff ? 'today' : 'later';
        const left = cutoff - now.minutes;
        const windowMinutes = Number(this.getAttribute('countdown-hours') || 0) * 60;
        if (beforeCutoff && windowMinutes > 0 && left <= windowMinutes) {
          const h = Math.floor(left / 60), m = left % 60;
          const time = h ? (m ? `${h}h ${m}m` : `${h}h`) : `${Math.max(m, 1)}m`;
          headline.textContent = this.dataset.countdownDispatch.replace('__time__', time);
        } else {
          headline.textContent = beforeCutoff ? this.dataset.today : this.dataset.later.replace('__day__', this.label(dispatch, now.date));
        }
        const estimate = this.querySelector('[data-delivery-line]');
        if (estimate) {
          estimate.textContent = this.dataset.estimate.replace('__day__', this.label(this.nextWorkday(dispatch), now.date));
          estimate.hidden = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
